import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { push } from "react-router-redux";
import Input from "../../../../components/form/Input";
import DatePicker from "../../../../components/form/DateTime";
import Button from "../../../../components/form/Button";
import AutoComplete from "../../../../components/form/AutoComplete";
import Select from "../../../../components/form/Select";
import CroField from "../../components/generalForm/CroField";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import { styles } from "../../index";
import * as V from "../../../../utils/formValidation";
import { get, join, isEmpty, isString } from "lodash";
import { getDecodedUser } from "../../../../utils/login";
import {isOvm, isInternal, isOfficialAdmin, isAdmin} from "../../CroUtils";
import H, { enumOnCondition } from "../../helpEnum";
import { ReleasedType } from "../../enum";
import { InspectionWorkingPositionGrid } from "../grids/InspectionGrid";

class WorkingPositionAddForm extends Component {
  state = {
    showRelease: false,
    clenZastup: false,
  };

  getWpId = (fromProps) => {
    const wp = fromProps.wp || { id: "" };
    return isString(wp) ? wp : wp.id;
  };

  getWpName = (fromProps) => {
    const wp = fromProps.wp || { name: "" };
    return isString(wp) ? wp : wp.name;
  };

  onOpenInspection = (inspection) => {
    const { auth, officialId } = this.props;
    this.props.dispatch(push(`${auth.startUrl}/funkcionari/${officialId}/kontroly/${inspection.id}`));
  };

  componentDidUpdate(prevProps) {
    const prevWPId = this.getWpId(prevProps);
    const newWPId = this.getWpId(this.props);
    if (prevWPId !== newWPId) {
      const showRelease =
        (this.getWpName(this.props).includes("člen Rady") ||
          this.getWpName(this.props).includes("člen rady") ||
          this.getWpName(this.props).includes("starost") ||
          this.getWpName(this.props).includes("zastupitelstva") || //condition copied from BE (up to here)
          this.getWpName(this.props).includes("hejtman")) && //"hejtman" is extra only for Release dropdown, not for "isCity" logic
        !this.getWpName(this.props).includes("uvolněný"); //"uvolněný člen zastupitelstva" shouldnt have Release dropdown, but has "isCity" logic

      const clenZastup = this.getWpName(this.props).includes("zastupitelstva");

      if (this.state.showRelease && !showRelease) {
        this.props.change("released", null);
      }
      this.setState({ showRelease, clenZastup });
    }
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      goBack,
      submitting,
      disabled,
      auth,
      ovmIds,
      officialId,
      end
    } = this.props;
    const { showRelease, clenZastup } = this.state;
    const ids = isOvm(auth)
      ? [get(getDecodedUser(), "sub", null)]
      : isInternal(auth)
        ? ovmIds
        : null;
    const url = !isEmpty(ids)
      ? `/api/ciselniky/funkce/doplneniOvm/${join(ids, ",")}`
      : "/api/ciselniky/funkce/doplneni/vse";

    const o = enumOnCondition(isOvm(auth));
    const releasedEnum = clenZastup
      ? ReleasedType.filter((e) => e.id === "RELEASED")
      : ReleasedType;

    const wpId = this.props.initialValues.id;
    const inspectionsUrl = `${auth.startUrl}/api/funkcionari/${officialId}/funkce/${wpId}/kontroly`;

    return (
      <form onSubmit={handleSubmit(onSubmit)} className="cro-form wpAddForm">
        <Field
          name="id"
          type="hidden"
          component="input"
          style={{ display: "none" }}
        />
        <Field
          name="ovmId"
          type="hidden"
          component="input"
          style={{ display: "none" }}
        />

        <div className="wpAddForm__section">
          <div className="wpAddForm__grid">

            {/* Riadok 1: Funkce, Organizace, Uvolněnost */}
            <CroField
              className="third"
              title="Funkce"
              name="workingPosition"
              component={AutoComplete}
              fullWidth
              url={url}
              disabled={disabled}
              validate={[V.required, V.isDictionary]}
              helpEnum={o(H.OVM_WP.r)}
            />
            <CroField
              className="third"
              title="Organizace"
              name="organization"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
              helpEnum={o(H.OVM_ORG.r)}
            />
            {showRelease ? (
              <CroField
                className="third"
                title="Uvolněnost"
                name="released"
                component={Select}
                items={releasedEnum}
                fullWidth
                disabled={disabled}
                validate={[V.required]}
              />
            ) : <div />}
            {/* Riadok 2: dátumy zahájení */}
            <CroField
              className="third"
              title="Datum zahájení výkonu funkce"
              name="start"
              component={DatePicker}
              fullWidth
              disabled={disabled}
              validate={[V.required, V.beforeToday]}
              helpEnum={o(H.OVM_WP_START.r)}
            />
            <CroField
              className="third"
              title="Datum předání informace o zápisu zahájení výkonu funkce"
              name="dateOfStart"
              component={DatePicker}
              fullWidth
              disabled={disabled}
              validate={[V.beforeToday]}
              helpEnum={o(H.OVM_WP_FILL_START.r)}
            />
            {(isOvm(auth) || isInternal(auth)) ? (
              <CroField
                className="third"
                title="Datum zápisu zahájení výkonu funkce"
                name="writtenDateOfStart"
                component={DatePicker}
                fullWidth
                validate={[V.beforeToday]}
                disabled={!isOfficialAdmin(auth)}
                helpEnum={o(H.OVM_WP_FILL_START.r)}
              />
            ) : <div />}

            {/* Riadok 3: dátumy ukončení */}
            <CroField
              className="third"
              title="Datum ukončení výkonu funkce"
              name="end"
              component={DatePicker}
              fullWidth
              disabled={disabled}
              helpEnum={o(H.OVM_WP_END.r)}
              validate={[V.beforeToday]}
            />
            <CroField
              className="third"
              title="Datum předání informace o zápisu ukončení výkonu funkce"
              name="dateOfEnd"
              component={DatePicker}
              fullWidth
              disabled={disabled}
              validate={[V.beforeToday]}
              helpEnum={o(H.OVM_WP_FILL_END.r)}
            />
            {(isOvm(auth) || isInternal(auth)) ? (
                <CroField
                    className="third"
                    title="Datum zápisu ukončení výkonu funkce"
                    name="writtenDateOfEnd"
                    component={DatePicker}
                    fullWidth
                    disabled={!isOfficialAdmin(auth)}
                    helpEnum={o(H.OVM_WP_FILL_END.r)}
                    validate={[V.beforeToday]}
                />
            ) : <div />}

            {/* Riadok 4: Lhůty (oddělené od ostatních polí) */}
            {(isOvm(auth) || isInternal(auth)) && (
                <>
                  <div className="wpAddForm__rowBreak" />
                  <CroField
                      className="third"
                      title="Lhůta pro podání vstupního oznámení do"
                      name="ingoingDeadline"
                      component={DatePicker}
                      fullWidth
                      disabled={true}
                  />
                  <CroField
                      className="third"
                      title="Lhůta pro podání výstupního oznámení do"
                      name="outgoingDeadline"
                      component={DatePicker}
                      fullWidth
                      disabled={true}
                  />
                </>
            )}
          </div>

          {/* Kontroly */}
          {(isOfficialAdmin(auth) || isAdmin(auth)) && (
            <div className="wpAddForm__section">
              <CroLabeledCmp title="Kontroly">
                <InspectionWorkingPositionGrid
                    gridName="officialInspectionWorkingPositionGrid"
                    url={inspectionsUrl}
                    onRowClick={this.onOpenInspection}
                />
              </CroLabeledCmp>
            </div>
          )}
        </div>

        <div className="wpAddForm__footer">
          <div className="wpAddForm__footerInner">
            {error && <div className="error">{error}</div>}
            {!this.props.valid && this.props.submitFailed && !error && (
              <div className="error">Povinná pole nejsou správně vyplněna.</div>
            )}
            {!disabled && (
              <div className="wpAddForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>
            )}

            <div className="wpAddForm__actions">
              {!disabled && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
              )}
              <Button
                type="button"
                style={styles.buttons}
                label="Zpět"
                disabled={submitting}
                onClick={goBack}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const WPForm = reduxForm({
  form: "wpForm",
  validate: V.startBeforeEnd("start", "end"),
})(WorkingPositionAddForm);

const selector = formValueSelector("wpForm");

export default connect((state) => ({
  wp: selector(state, "workingPosition"),
  end: selector(state, "end"),
}))(WPForm);
